import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const DeleteProperty = () => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchProperties = async () => {
    setLoading(true);
    try {
      const res = await axios.get("https://investorrise-gxm0.onrender.com/api/properties");
      setProperties(res.data);
    } catch (err) {
      console.error("Failed to fetch properties:", err);
    } finally {
      setLoading(false);
    }
  };

  const deleteProperty = async (id) => {
    if (!window.confirm("Are you sure you want to delete this property?")) return;
    try {
      await axios.delete(`https://investorrise-gxm0.onrender.com/api/properties/${id}`);
      setProperties((prev) => prev.filter((p) => p._id !== id));
    } catch (err) {
      console.error("Failed to delete property:", err);
    }
  };

  useEffect(() => {
    fetchProperties();
  }, []);

  return (
    <div className="pt-28 pb-20 bg-slate-800 min-h-screen px-4 pt">
         <Link to="/add-property">
                      <button className="relative overflow-hidden py-3 px-8 mt-4 mb-2 text-white font-semibold bg-slate-900 shadow-xl text-lg group ml-4">
                <span className="absolute inset-0 bg-gradient-to-r from-teal-500 to-teal-500 group-hover:from-teal-500 group-hover:to-teal-500 animate-slide-bg transition-all duration-500 ease-in-out"></span>
                <span className="relative z-10">Go Back</span>
              </button>
              </Link>
  <h2 className="text-2xl font-semibold text-white mb-6 text-center">Delete Property</h2>
  {loading ? (
    <p className="text-white text-center">Loading properties...</p>
  ) : properties.length === 0 ? (
    <p className="text-white text-center">No properties found.</p>
  ) : (
    <div className="max-w-4xl mx-auto px-4 ">
      <ul className="space-y-6">
        {properties.map((property) => (
          <li
            key={property._id}
            className="bg-slate-900 shadow-lg rounded-xl p-4 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 shadow-md shadow-teal-500"
          >
            <div className="flex gap-4 w-full sm:w-auto ">
              {property.mainImage && (
                <img
                  src={`https://investorrise-gxm0.onrender.com${property.mainImage}`}
                  alt={property.title}
                  className="w-32 h-24 object-cover rounded-md border"
                />
              )}
              <div className="flex flex-col justify-center">
                <h4 className="text-lg font-semibold text-white">{property.title}</h4>
                 <p className="text-slate-300 font-bold text-sm">Price: ${property.price || "N/A"}</p>
                <p className="text-slate-300 font-bold text-sm mt-1">Area: {property.area || "N/A"} sqft</p>
               
              </div>
            </div>
            <button
              onClick={() => deleteProperty(property._id)}
              className="bg-red-600 hover:bg-red-700 text-white px-4 py-2  transition duration-200 w-full sm:w-auto"
            >
              Delete
            </button>
          </li>
        ))}
      </ul>
    </div>
  )}
</div>

  );
};

export default DeleteProperty;
